import { Component, Vue, Watch } from 'vue-property-decorator'

import dateHelper from '@/helpers/date'

import Loader from '@/components/Loader/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlusCircle,
	faExternalLinkAlt,
	faFilePdf,
	faStarHalfStroke,
	faPenClip,
	faFilter,
} from '@fortawesome/free-solid-svg-icons'

import { faBlackTie } from '@fortawesome/free-brands-svg-icons'
import fetch from '@/helpers/fetch'

import VueTrix from 'vue-trix'

import Judiciary from './Judiciary/index.vue'
import Administrative from './Administrative/index.vue'

library.add(
	faPlusCircle,
	faExternalLinkAlt,
	faFilePdf,
	faStarHalfStroke,
	faPenClip,
	faBlackTie,
	faFilter,
)

@Component({
	components: {
		Loader,
		FieldDatePortal,
		Judiciary,
		Administrative,
	},
})
export default class Emails extends Vue {
	tabs = ['Judicial', 'Administrativo']
	activeTab = 'Judicial'

	mounted() {
		this.applyHash(this.$route.hash)
	}

	@Watch('$route.hash')
	onHashChange(hash: string) {
		this.applyHash(hash)
	}

	applyHash(hash: string) {
		if (hash === '#administrativo' || hash === '#administrativo-especifico') {
			this.activeTab = 'Administrativo'
		} else {
			this.activeTab = 'Judicial'
		}
	}

	switchTab(tab: string) {
		this.activeTab = tab
		const hash = tab === 'Administrativo' ? '#administrativo' : ''
		if (this.$route.hash !== hash) {
			this.$router.replace({ hash })
		}
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
	}
}
